import React, { useState, useEffect } from 'react'
import { useContextState } from '../../context/Context';
import { Button, Select } from 'flowbite-react';
import { useCacheApi } from "../../store";
import Loader from '../shared/Loader';
import AlertComponent from '../shared/AlertComponent';

const CacheClear = () => {
    const { emptyCache, clearEventCache, clearCustomCache } = useCacheApi();
    const { cacheCTX } = useContextState();
    const { cacheState } = cacheCTX;

    const [currentSubView, setCurrentSubView] = useState<string>('default');
    const [message, setMessage] = useState<string>('');
    const [userId, setUserId] = useState<string>('');
    const [eventId, setEventId] = useState<string>('');
    const [cacheId, setCacheId] = useState<string>('');

    useEffect(() => {
        document.title = 'FestiShare Support - Cache';
    }, []);

    const CallClearEventCache = async (userId: string, eventId: string) => {
        const result: any = await clearEventCache({ userId, eventId });
        if (result?.res === 'success') {
            setCurrentSubView('success');
        } else {
            setMessage(result?.message || 'Sorry, there was an error clearing cache.');
            setCurrentSubView('error');
        }
    };

    const CallClearCustomCache = async (cacheType: string, cacheId: string) => {
        const result: any = await clearCustomCache({ cacheType, cacheId });
        if (result?.res === 'success') {
            setCurrentSubView('success');
        } else {
            setMessage(result?.message || 'Sorry, there was an error clearing cache.');
            setCurrentSubView('error');
        }
    };

    const CallEmptyCache = async (password: string) => {
        const result: any = await emptyCache({ password });
        if (result?.res === 'success') {
            setCurrentSubView('success');
        } else {
            setMessage(result?.message || 'Sorry, there was an error clearing cache.');
            setCurrentSubView('error');
        }
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (cacheState === 'events') {
            const userIdValue = e.currentTarget.userId.value;
            const eventIdValue = e.currentTarget.eventId.value;
            setUserId(userIdValue);
            setEventId(eventIdValue);
            CallClearEventCache(userIdValue, eventIdValue);
        } else if (cacheState === 'custom') {
            const cacheTypeValue = e.currentTarget.cacheType.value;
            const cacheIdValue = e.currentTarget.cacheId.value;
            setCacheId(cacheIdValue);
            CallClearCustomCache(cacheTypeValue, cacheIdValue);
        } else if (cacheState === 'all') {
            const passwordValue = e.currentTarget.password.value;
            CallEmptyCache(passwordValue);
        }
    };

    return (
        <div className="mt-20 mb-20">
            <div className="mx-auto max-w-3xl px-6 lg:px-8">

                {currentSubView === 'loader' && <Loader />}

                {currentSubView === 'default' && (
                    <form onSubmit={handleSubmit}>
                        {cacheState === 'events' && (
                            <div>
                                <h2 className="text-base font-semibold leading-7 text-gray-900">Clear Events Cache</h2>
                                <div className="mb-2 block mt-6">
                                    <label htmlFor="userId" className="block text-sm font-medium leading-6 text-gray-900">
                                        User's Username
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            type="text"
                                            name="userId"
                                            id="userId"
                                            defaultValue={userId}
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>
                                <div className="mt-3 w-full flex justify-between items-center">
                                    <hr className="w-2/5" />
                                    <span className="uppercase">OR / AND</span>
                                    <hr className="w-2/5" />
                                </div>
                                <div className="mb-2 block mt-6">
                                    <label htmlFor="eventId" className="block text-sm font-medium leading-6 text-gray-900">
                                        Event ID
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            type="text"
                                            name="eventId"
                                            id="eventId"
                                            defaultValue={eventId}
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>
                                <div className="w-full flex justify-center mt-6">
                                    <Button type='submit'>Continue</Button>
                                </div>
                            </div>
                        )}

                        {cacheState === 'custom' && (
                            <div>
                                <h2 className="text-base font-semibold leading-7 text-gray-900">Clear Custom Cache</h2>
                                <div className="mb-2 block mt-6">
                                    <label htmlFor="cacheType" className="block text-sm font-medium leading-6 text-gray-900">
                                        Cache Type
                                    </label>
                                    <div className="mt-2">
                                        <Select id="cacheType" required>
                                            <option value=''>Select type</option>
                                            <option value='profilePicture'>Profile Picture</option>
                                            <option value='picture'>Event Picture</option>
                                            <option value='promoter'>Promoter</option>
                                            <option value='promoters'>Promoters</option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="mb-2 block mt-6">
                                    <label htmlFor="cacheId" className="block text-sm font-medium leading-6 text-gray-900">
                                        Cache ID
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            type="text"
                                            name="cacheId"
                                            id="cacheId"
                                            required
                                            defaultValue={cacheId}
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>
                                <div className="w-full flex justify-center mt-6">
                                    <Button type='submit'>Continue</Button>
                                </div>
                            </div>
                        )}

                        {cacheState === 'all' && (
                            <div>
                                <h2 className="text-base font-semibold leading-7 text-gray-900">Clear All Cache</h2>
                                <div className="mb-2 block mt-6">
                                    <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                                        Password
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            type="password"
                                            name="password"
                                            id="password"
                                            required
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>
                                <div className="w-full flex justify-center mt-6">
                                    <Button type='submit'>Continue</Button>
                                </div>
                            </div>
                        )}
                    </form>
                )}

                {currentSubView === 'success' && (
                    <AlertComponent
                        callBack={() => setCurrentSubView('default')}
                        type='success'
                        subject='Success'
                        message='Cache cleared successfully.'
                    />
                )}

                {currentSubView === 'error' && (
                    <AlertComponent
                        callBack={() => setCurrentSubView('default')}
                        type='error'
                        subject='Failed'
                        message={message}
                    />
                )}
            </div>
        </div>
    );
};

export default CacheClear;
